import { render } from "./Horizontal.vue?vue&type=template&id=f619480e&scoped=true"
import script from "./Horizontal.vue?vue&type=script&lang=js"
export * from "./Horizontal.vue?vue&type=script&lang=js"

import "./Horizontal.vue?vue&type=style&index=0&id=f619480e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f619480e"]])

export default __exports__